export class CompanyCheck {
	public static isUniqaPL(companyShortName: string | null | undefined): boolean {
		if (companyShortName == null) return false;

		let name = companyShortName.toLowerCase();
		return name === 'uniqapl' || name === 'pevno';
	}

	public static isSolvd(companyShortName: string | null | undefined): boolean {
		if (companyShortName == null) return false;

		let name = companyShortName.toLowerCase();
		return name === 'solvd';
	}

	public static isControlExpertCEE(companyShortName: string | null | undefined): boolean {
		if (companyShortName == null) return false;

		let name = companyShortName.toLowerCase();
		return name === 'controlexpertcee';
	}

	public static isGPUProcess(companyShortName: string | null | undefined): boolean {
		if (companyShortName == null) return false;

		return companyShortName.toLowerCase().includes('gpu');
	}
}
